import { render, staticRenderFns } from "./EditAssetInfo.vue?vue&type=template&id=50f38fe9&"
import script from "./EditAssetInfo.vue?vue&type=script&lang=js&"
export * from "./EditAssetInfo.vue?vue&type=script&lang=js&"
import style0 from "./EditAssetInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports